import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import LessonNavigatorAsset from './LessonNavigatorAsset';
import ACVerticalStepper from '../../progress/ACVerticalStepper';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import styled from 'styled-components';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColorOnHover = styled.span.withConfig({
  displayName: "ACLessonNavigator__ColorOnHover"
})(["&:hover h4{color:", ";}"], ({
  theme
}) => theme.color['text-interactive-default-hover']);
const ACLessonNavigator = ({
  title,
  helpText,
  assets,
  activeAssetId,
  active,
  optionalSteps,
  menuIcon,
  lessonId,
  courseId
}) => {
  const [expanded, setExpanded] = useState(active);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: active ? 'fill-surface-recessed' : 'fill-surface-default',
    "data-test-id": "lesson-navigator-container",
    overflow: "hidden",
    padding: "400",
    children: /*#__PURE__*/_jsxs(AccordionItem, {
      "data-test-id": "lesson-navigator-item",
      onOpenChange: () => setExpanded(!expanded),
      open: expanded,
      size: "md",
      title: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "-300",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsxs(Box, {
            grow: 1,
            children: [/*#__PURE__*/_jsx(ColorOnHover, {
              children: /*#__PURE__*/_jsx(Text, {
                as: "h4",
                marginBlockEnd: "100",
                children: title
              })
            }), helpText && /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: helpText
            })]
          }), menuIcon && /*#__PURE__*/_jsx(Box, {
            "data-test-id": "menu-icon",
            children: menuIcon
          })]
        })
      }),
      children: [/*#__PURE__*/_jsx(List, {
        children: /*#__PURE__*/_jsx(ACVerticalStepper, {
          activeStep: assets.findIndex(asset => asset.id === activeAssetId),
          iconOffset: "400",
          renderStep: step => /*#__PURE__*/_jsx(ListItem, {
            marginBlock: "100",
            children: /*#__PURE__*/_jsx(LessonNavigatorAsset, {
              active: step.id === activeAssetId,
              courseId: courseId,
              helpText: step.helpText,
              id: step.id,
              lessonId: lessonId,
              title: step.title
            }, step.id)
          }),
          steps: assets
        })
      }), optionalSteps && /*#__PURE__*/_jsx(View, {
        "data-test-id": "optional-steps",
        marginInlineStart: "-700",
        children: optionalSteps
      })]
    })
  });
};
export default ACLessonNavigator;